import axios from '../../axios'

export default {
  getRegions: function (selectAll) {
    if (selectAll !== null && selectAll !== undefined) {
      return axios.get('regions?all=' + selectAll)
    } else {
      return axios.get('regions?all=true')
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/api/RegionsApi.js